import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classnames from 'classnames';
import omit from 'lodash/omit';

var Radio = function (_React$Component) {
  _inherits(Radio, _React$Component);

  var _super = _createSuper(Radio);

  function Radio(props) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _super.call(this, props);

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          checked = _this$props.checked,
          disabled = _this$props.disabled;

      if (disabled) {
        return;
      }

      if (checked === undefined) {
        _this.setState({
          checked: e.currentTarget.checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    var _checked = !!props.defaultChecked;

    if (props.checked !== undefined) {
      _checked = !!props.checked;
    }

    _this.state = {
      checked: _checked
    };
    return _this;
  }

  _createClass(Radio, [{
    key: "renderInput",
    value: function renderInput() {
      var checked = this.state.checked;
      var nativeProps = omit(this.props, ['defaultChecked', 'className', 'checked', 'children', 'style']);
      return React.createElement("span", {
        className: "Radio__input"
      }, React.createElement("input", Object.assign({}, nativeProps, {
        type: "radio",
        className: "Radio__native-input",
        checked: checked,
        onChange: this.handleChange
      })), React.createElement("span", {
        className: "Radio__box"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var checked = this.state.checked;
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          className = _this$props2.className,
          children = _this$props2.children;

      var _className = classnames(className, 'Radio', {
        'Radio--checked': checked,
        'Radio--disabled': disabled
      });

      return React.createElement("label", {
        className: _className
      }, this.renderInput(), children && React.createElement("span", {
        className: "Radio__text"
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.checked !== undefined && prevState.checked !== nextProps.checked) {
        return {
          checked: !!nextProps.checked
        };
      }

      return null;
    }
  }]);

  return Radio;
}(React.Component);

Radio.isFormControl = true;
Radio.defaultProps = {
  checked: undefined,
  defaultChecked: false,
  disabled: false,
  onChange: undefined,
  className: undefined,
  children: undefined
};
export default Radio;